module.exports = __webpack_public_path__ + "sprstatic/img/yinlian.2838cd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/yinlian.png
// module id = cwZ4
// module chunks = 2